export const WEB_MAX_WIDTH = 1000
export const WEB_MAX_WIDTH_FOR_BANNER = 390
export const WEB_MAX_WIDTH_FOR_ORGANIZATION_ICON = 240

export const PAYED_TEAM_MIGRATE_NOT_ALLOWED =
  "エラーコード023\n「らくらく連絡網＋」は有料版の機能を搭載していないため、現状移行できません。"

export const TIME_INTERVAL_REPLY_THREAD = 30000
